import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {WebApiHttp} from "../../../../@pristinebase/Process/WebApiHttp.services";
import {PristineToaster} from "../../../../@pristinebase/Process/ZivameServices/PristineToaster";
import {SessionManageMent} from "../../../../@pristinebase/Process/SessionManageMent";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'Attendance',
    templateUrl: './attendance.component.html',
    styleUrls: ['./attendance.component.scss'],
})
export class AttendanceComponent implements OnInit {
    constructor(private _webApiHttp: WebApiHttp,
                private _session: SessionManageMent,
                private _dig: MatDialog) {    }
    stream = null;
    selectType=''
    @ViewChild('canvas',{static: true}) canvas: ElementRef
    @ViewChild('video',{static: true}) video: ElementRef
    @ViewChild('image',{static: true}) image: ElementRef

    ngOnInit() {
        // this.getTodaysAttendencee()
    }

    // getTodaysAttendencee(){
    //     let day = new Date().getDate()
    //     let month = new Date().getMonth()
    //     let year = new Date().getFullYear()
    //     this._webApiHttp.Get(this._webApiHttp.ApiURLArray.getTodaysAttendence +
    //         this._session.getEmail+'&working_date='+year+'/'+month+'/'+day).then(res=>{
    //        if(res.length>0 && res[0].condition.toString().toLowerCase() == 'false'){
    //            // this._dig.open(this.markToday)
    //        }
    //     }).catch(err=> console.log(err))
    // }
    async getMedia(param){
        try{
            this.stream = await navigator.mediaDevices.getUserMedia({video: true})
            console.log(this.stream, param)
        }catch(err){
         console.log(err)
        }
    }

    closeCamera(){
        this.stream.getTracks().forEach((track)=>{
            track.stop()
        })
    }

    imageCapture(){
        setTimeout(()=>{
            this.canvas.nativeElement.getContext('2d').drawImage(this.video.nativeElement(0,0,400,400))
            this.image.nativeElement.setAttribute('src', this.canvas.nativeElement.toDataURL('image/png'))
        }, 100)

    }
}

